export const useBlurQuestion = () => (): void => undefined;
